var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { formatReportModuleParams, useReport } from '@tencent/dz-report';
import { useEffect } from 'react';
import { useMessageModel } from '../../../hooks';
export var useReportService = function (query, config) {
    var report = useReport();
    var messageModel = useMessageModel();
    var reportParams = {
        module_id: '',
        module_type: 'card_queryword_preinput',
        module_chinese_type: '搜索词预输入',
        module_value: query,
        element_chinese_type: '预输入卡片',
        element_type: 'card_queryword_preinput',
        element_content: query,
    };
    useEffect(function () {
        searchTermExposure();
        if (config.preinput_enable === 1 && config.preinput_type === 2 && query !== '') {
            searchTermSendExposure(query);
        }
    }, []);
    var reportModuleParams = formatReportModuleParams(reportParams, {});
    var searchTermExposure = function () {
        report.exposure(reportParams);
    };
    var searchTermEditClick = function (query) {
        report.click(__assign(__assign({}, reportParams), { element_chinese_type: '预输入卡片_编辑', element_type: 'edit', element_content: query }));
    };
    var searchTermSendClick = function (query) {
        report.click(__assign(__assign({}, reportParams), { element_chinese_type: '预输入卡片_发送', element_type: 'send', element_content: query }));
    };
    var searchTermSendExposure = function (query) {
        var searchQuery = query === '' ? '' : "\u6211\u60F3\u54A8\u8BE2" + query;
        report.exposure(__assign(__assign({}, reportParams), { element_chinese_type: '预输入卡片_聊天框发送', element_type: 'chat_box_send', element_id: searchQuery, element_content: messageModel.inputMessage }));
    };
    return {
        searchTermExposure: searchTermExposure,
        searchTermEditClick: searchTermEditClick,
        searchTermSendClick: searchTermSendClick,
        reportModuleParams: reportModuleParams,
        searchTermSendExposure: searchTermSendExposure,
    };
};
